import { createClient } from "@supabase/supabase-js";

// CRM uses a dedicated Supabase project (llyll-crm-prod), distinct from the
// Videolink auth project. If the env vars are not set at build time, we expose
// `null` and the UI falls back to mock data — this lets the /crm path render
// on test.videolink.llyll.com before the project is provisioned.
const url = import.meta.env.VITE_CRM_SUPABASE_URL;
const anonKey = import.meta.env.VITE_CRM_SUPABASE_ANON_KEY;

export const crmSupabase =
  url && anonKey
    ? createClient(url, anonKey, {
        db: { schema: "crm" },
        auth: { persistSession: false },
      })
    : null;

export const crmConfigured = crmSupabase !== null;
